import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
} from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { connect, useDispatch } from "react-redux";
import { Row, Col, Card, Tab, Nav, Button } from "react-bootstrap";
import {
  getCandidatesJob,
  getCandidateById,
  updateCandidates,
} from "../../../store/actions/Candidates/candidateActions";
import { withRouter } from "../../../App";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import CandidateJobs from "./CandidateJobs";
import CandidateGDPR from "./CandidateGDPR";
import Documents from "./Documents";
import { industrySector } from "../../constant/industrySector";
import { countries } from "../../constant/country";
import { get, post } from "../../../services/api";
import EmailLog from "../Common/EmailLog";
import { debounce } from "../../../utils/debounce";
import ViewContactLog from "../Common/ViewContactLog";
import ComplianceCriteria from "./ComplianceCriteria";
import IDCard from "./IDCard";
import Select from "react-select";
import dayjs from "dayjs";

const AddCandidateMaster = ({ token, selectedCandidate, candidateSources, candidateStatus, employmentTypes, visaTypeValues,
  qualification,
  skills,
  jobTitle }) => {
  const [query, setQuery] = useState(""); // User's input
  const [results, setResults] = useState([]); // API results
  const [sourceList, setSourceList] = useState([]);
  const [weekEmployed, setWeekEmployed] = useState(0);
  const [statusList, setStatusList] = useState([]);
  const [employmentTypeList, setEmploymentTypeList] = useState([]);
  const [visaTypes, setVisaTypes] = useState([]);

  const [qualificationList, setQualificationList] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [jobTitleList, setJobTitleList] = useState([]);

  useEffect(() => {
    if (candidateSources) {
      setSourceList(candidateSources?.map((itm) => itm.value));
    }
    if (candidateStatus) {
      setStatusList(candidateStatus?.map((itm) => itm.value));
    }
    if (employmentTypes) {
      setEmploymentTypeList(employmentTypes?.map((itm) => itm.value));
    }

    if (visaTypeValues) {
      setVisaTypes(visaTypeValues?.map((itm) => itm.value));
    }

    if (qualification) {
      setQualificationList(qualification?.map((itm) => itm.value));
    }

    if (skills) {
      setSkillList(skills?.map((itm) => itm.value));
    }

    if (jobTitle) {
      setJobTitleList(jobTitle?.map((itm) => itm.value));
    }


  }, [candidateSources, candidateStatus, employmentTypes, visaTypeValues, qualification, skills, jobTitle]);

  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(
      `https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    // Destructure the API response
    const {
      line_1: addressLine1 = "",
      line_2: addressLine2 = "",
      town_or_city: town = "",
      county = "",
      country = "",
      postcode: postCode = "",
      region = "",
    } = result;

    // Update the form data with the new address details
    setFormData((prevFormData) => ({
      ...prevFormData,
      addressLine1,
      addressLine2,
      town,
      county,
      country,
      postCode,
      region,
    }));
    // setFormData({ ...formData, [field]: value });
    setResults([]); // Clear suggestions after selection
  };

  const fetchData = async (searchTerm) => {
    const apiData = await fetch(
      `https://api.getaddress.io/autocomplete/${searchTerm}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    setResults(result.suggestions);
    console.log(results);
  };

  // Handle input changes
  const handlePostCodeQueryChange = (inputQuery) => {
    setQuery(inputQuery); // Update input state
    debounce(fetchData(inputQuery)); // Call the debounced function
  };

  const [searchParams] = useSearchParams();
  const nav = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.state?.returnPath) {
      nav(location.state.returnPath, {
        state: {
          openCandidatesModal: true,
          selectedRequirement: location.state.selectedRequirement
        }
      });
    } else {
      nav(-1);
    }
  };
  const updateCandidateId = searchParams.get("id");
  const formMode = searchParams.get("mode");
  const isView = formMode === "view";

  useEffect(() => {
    if (updateCandidateId) {
      dispatch(getCandidateById(updateCandidateId, token));
      dispatch(getCandidatesJob(updateCandidateId, token));
    }
  }, [updateCandidateId]);

  const tabData = [
    {
      name: "Master",
      icon: "home",
    },
    {
      name: "Details",
      icon: "info-circle",
    },
    {
      name: "Classification",
      icon: "certificate",
    },
    {
      name: "Payroll",
      icon: "money-bill-wave",
    },
    {
      name: "Pen Picture",
      icon: "pen-nib",
    },
    {
      name: "Jobs",
      icon: "hammer",
    },

    // {
    //   name: "CV",
    //   icon: "book-reader",
    // },
    {
      name: "Email Log",
      icon: "envelope",
    },
    {
      name: "GDPR",
      icon: "book-open",
    },
    {
      name: "Contact Log",
      icon: "phone",
    },
    {
      name: "Registration Form ",
      icon: "file-contract",
    },
    {
      name: "Compliance Criteria",
      icon: "passport",
    },
    {
      name: "ID Card",
      icon: "id-card",
    },
  ];
  const contactLogRef = useRef();
  const idCardRef = useRef();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    knownAs: "",
    addressLine1: "",
    addressLine2: "",
    town: "",
    county: "",
    country: "",
    postCode: "",
    region: "",
    phone: "",
    phoneNumber: "",
    email: "",
    office: "",
    sector: "",
    personId: "",
    consultant: "",
    regDate: null,
    source: "",
    recordUpdated: null,
    statusDate: null,
    status: "LIVE",
    industrySector: "",
    jobTitles: "",
    skills: "",
    qualifications: [],
    marketing: "",
    allowedHoursPerWeek: "",
    vehicleLicense: "",
    hasVehicle: false,
    hasDrivingLicense: false,
    hasNoLimitOnExpiry: false,
    drivingLicense: "",
    dateOfBirth: "",
    paymentDetails: {
      employmentType: 'PAYE'
    }
  });

  useEffect(() => {
    console.log("selectedCandidate", selectedCandidate);
    setFormData({
      dateOfBirth: selectedCandidate?.dateOfBirth
        ? new Date(selectedCandidate.dateOfBirth)
        : null,
      allowedHoursPerWeek: selectedCandidate?.allowedHoursPerWeek,
      //? new Date(selectedCandidate.dateOfBirth) : null,
      age: selectedCandidate?.dateOfBirth ? calculateAge(selectedCandidate?.dateOfBirth) : "",
      nationality: selectedCandidate?.nationality || "",
      visaType: selectedCandidate?.visaType || "",
      paymentDetails: {
        ...selectedCandidate?.paymentDetails,
        employmentType: selectedCandidate?.paymentDetails?.employmentType || 'PAYE'
      },
      visaExpiry: selectedCandidate?.visaExpiry
        ? new Date(selectedCandidate.visaExpiry)
        : null,
      maritalStatus: selectedCandidate?.maritalStatus || "",
      industrySector: selectedCandidate?.industrySector || "",
      jobTitles: selectedCandidate?.jobTitles || "",
      skills: selectedCandidate?.skills || "",
      qualifications: selectedCandidate?.qualifications || [],
      marketing: selectedCandidate?.marketing || "",
      title: selectedCandidate?.title || "",
      firstName: selectedCandidate?.firstName || "",
      lastName: selectedCandidate?.lastName || "",
      knownAs: selectedCandidate?.knownAs || "",
      addressLine1: selectedCandidate?.address?.[0]?.addressLine1 || "",
      addressLine2: selectedCandidate?.address?.[0]?.addressLine2 || "",
      town: selectedCandidate?.address?.[0]?.town || "",
      county: selectedCandidate?.address?.[0]?.county || "",
      country: selectedCandidate?.address?.[0]?.country || "",
      postCode: selectedCandidate?.address?.[0]?.postcode || "",
      region: selectedCandidate?.address?.[0]?.region || "",
      phone: selectedCandidate?.contact?.phoneType || "",
      phoneNumber: selectedCandidate?.contact?.phoneNumber || "",
      email: selectedCandidate?.email || "",
      office: selectedCandidate?.office || "",
      sector: selectedCandidate?.sector || "",
      personId: selectedCandidate?.personId || "",
      consultant: selectedCandidate?.consultant || "",
      penPicture: selectedCandidate?.penPicture,
      testimonial: selectedCandidate?.testimonial,
      payrollNo: selectedCandidate?.payrollNo,
      weeksEmployed: selectedCandidate?.weeksEmployed,
      twelveWeekAverage: selectedCandidate?.twelveWeekAverage,
      tempStartDate: selectedCandidate?.tempDetails?.stempStartDate
        ? new Date(selectedCandidate?.tempDetails?.stempStartDate)
        : null,
      tempFinishDate: selectedCandidate?.tempDetails?.tempFinishDate
        ? new Date(selectedCandidate?.tempDetails?.tempFinishDate)
        : null,
      type: selectedCandidate?.tempDetails?.type || "",

      niNo: selectedCandidate?.niNo,
      availDate: selectedCandidate?.availDate
        ? new Date(selectedCandidate?.availDate)
        : null,
      homeType: selectedCandidate?.address?.[0]?.addressType,
      rate: selectedCandidate?.rate,
      rateType: selectedCandidate?.rateType || "BASIC",
      pickupPoint: selectedCandidate?.pickupPoint,
      vehicleLicense: selectedCandidate?.vehicleLicense,
      hasVehicle: selectedCandidate?.hasVehicle || false,
      drivingLicense: selectedCandidate?.drivingLicense,
      hasDrivingLicense: selectedCandidate?.hasDrivingLicense || false,
      hasNoLimitOnExpiry: selectedCandidate?.hasNoLimitOnExpiry || false,
      awrType: selectedCandidate?.awrType || "Normal",
      hoursPerWeek: selectedCandidate?.hoursPerWeek,
      gdpr: selectedCandidate?.gdpr,
      regDate: selectedCandidate?.regDate
        ? new Date(selectedCandidate.regDate)
        : null,
      source: selectedCandidate?.source || "",
      recordUpdated: selectedCandidate?.recordUpdated
        ? new Date(selectedCandidate.recordUpdated)
        : null,
      statusDate: selectedCandidate?.statusDate
        ? new Date(selectedCandidate.statusDate)
        : null,
      status: selectedCandidate?.status || "LIVE",
    });
    if (selectedCandidate) {
      getWeeklyEmployedDetail();
    }
  }, [selectedCandidate]);

  const getWeeklyEmployedDetail = async () => {
    try {
      if (selectedCandidate?._id) {
        const res = await get(
          `/api/candidate/weeksEmployed/${selectedCandidate?._id}`,
          token
        );
        setWeekEmployed(res?.data?.weeksEmployed || 0);
      }
    } catch (e) {
      setWeekEmployed(0);
    }
  };

  const [errors, setErrors] = useState({});
  const [addEmploye, setAddEmploye] = useState(false);
  const [activeTab, setActiveTab] = useState(tabData[0].name.toLowerCase()); // Set initial active tab

  const handleSelect = (key) => {
    setActiveTab(key);
  };
  const validate = () => {
    const newErrors = {};
    if (activeTab === "master") {
      // Required fields
      const requiredFields = [
        "title",
        "firstName",
        "lastName",
        "postCode",
        "town",
        "country",
        "email",
        "phone",
        "phoneNumber",
      ];

      requiredFields.forEach((field) => {
        if (!formData[field].trim()) {
          newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
        }
      });

      // Email validation
      if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email must be valid.";
      }

      // Phone and Phone Number validation
      if (!formData.phone) {
        newErrors.phone = "Phone type is required.";
      }
      if (
        formData.phoneNumber &&
        !/^(?:\+44|0)\d{10}$/.test(formData.phoneNumber)
      ) {
        newErrors.phoneNumber = "Phone Number must be a valid UK mobile number.";
      }
    }

    if (activeTab === "details") {
      if (!formData.dateOfBirth) {
        newErrors.dateOfBirth = "Please enter your date of birth.";
      }
      // if (formData.hasVehicle) {
      //   if (!formData.vehicleLicense) {
      //     newErrors.vehicleLicense = "Please enter vehicle license.";
      //   }
      // }
      // if (formData.hasDrivingLicense) {
      //   if (!formData.drivingLicense) {
      //     newErrors.drivingLicense = "Please enter driving license.";
      //   }
      // }
      if (!formData.nationality) {
        newErrors.nationality = "Please select your nationality.";
      }

      if (formData.nationality !== "United Kingdom" &&
        formData.nationality !== "Ireland") {
        if (formData.visaType === '') {
          newErrors.visaType = "Please Enter Type of Visa.";
        }

        if (!formData.visaExpiry) {
          newErrors.visaExpiry = "Please Enter RTW Check expiry date.";
        }
      }
    }

    if (activeTab === "classification") {
      if (!formData.industrySector) {
        newErrors.industrySector = "Please select industry sector.";
      }
    }

    if (activeTab === "payroll") {
      if (!formData.payrollNo) {
        newErrors.payrollNo = "Please enter Payroll No.";
      }
      if (!formData.niNo) {
        newErrors.niNo = "Please enter NI No.";
      }
    }

    // if (activeTab === "pen picture") {
    //   if (!formData.penPicture) {
    //     newErrors.penPicture = "Please fill Pen picture field.";
    //   }
    // }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all the required fields.");
    }
    return Object.keys(newErrors).length === 0;
  };

  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleInputChange = (field, value) => {
    if (field === "postCode") {
      handlePostCodeQueryChange(value);
    }
    if (field === "dateOfBirth") {
      setFormData({ ...formData, age: calculateAge(value), [field]: value });
    } else {
      setFormData({ ...formData, [field]: value });
    }
    setErrors({ ...errors, [field]: "" }); // Clear specific field error
  };

  // Function to check if candidate with same details already exists
  // const checkDuplicateCandidate = async (firstName, lastName, email, currentCandidateId) => {
  //   try {
  //     const checkData = {
  //       firstName: firstName,
  //       lastName: lastName,
  //       email: email.toLowerCase(),
  //       currentCandidateId: currentCandidateId 
  //     };

  //     console.log('Checking for duplicate candidate with data:', checkData);

  //     // Using post to send data for checking duplicates
  //     const response = await 
  //     console.log('Duplicate check API response:', response);
  //     return response;
  //   } catch (error) {
  //     console.error('Error checking duplicate candidate:', error);
  //     return { isDuplicate: false, error: true };
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!validate()) return;

    const payload = {
      title: formData?.title,
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      knownAs: formData?.knownAs,
      address: [
        {
          addressType: formData?.homeType || "HOME",
          isDefault: true,
          addressLine1: formData?.addressLine1,
          addressLine2: formData?.addressLine2,
          town: formData?.town,
          county: formData?.county,
          country: formData?.country,
          postcode: formData?.postCode,
          region: formData?.region,
        },
      ],
      contact: {
        phoneType: formData?.phone,
        phoneNumber: formData?.phoneNumber,
      },
      email: formData?.email?.toLowerCase(),
      website: "",
      business: "Rapid Resourcing Ltd",
      office: "Liverpool",
      sector: formData?.sector,
      personId: formData?.personId,
      consultant: formData?.consultant,
      regDate: formData?.regDate,
      source: formData?.source,
      statusDate: formData?.statusDate,
      status: formData?.status,
      weeksEmployed: formData?.weeksEmployed,
      twelveWeekAverage: formData?.twelveWeekAverage,
      tempDetails: {
        tempStartDate: formData?.tempStartDate,
        tempFinishDate: formData?.tempFinishDate,
        type: formData?.type,
      },
      industrySector: formData?.industrySector || "",
      jobTitles: formData?.jobTitles || "",
      skills: formData?.skills || "",
      qualifications: formData?.qualifications || [],
      marketing: formData?.marketing || "",
      niNo: formData?.niNo,
      availDate: formData?.availDate,
      rate: formData?.rate,
      rateType: formData?.rateType,
      pickupPoint: formData?.pickupPoint,
      vehicleLicense: formData?.vehicleLicense,
      hasVehicle: formData?.hasVehicle,
      drivingLicense: formData?.drivingLicense,
      hasNoLimitOnExpiry: formData?.hasNoLimitOnExpiry,
      hasDrivingLicense: formData?.hasDrivingLicense,
      awrType: formData?.awrType,
      hoursPerWeek: formData?.hoursPerWeek,
      penPicture: formData?.penPicture,
      testimonial: formData?.testimonial,
      dateOfBirth: formData?.dateOfBirth,
      age: formData?.dateOfBirth ? calculateAge(formData?.dateOfBirth) : "",
      nationality: formData?.nationality || "",
      visaType: formData?.visaType || "",
      visaExpiry: formData?.visaExpiry ? new Date(formData.visaExpiry) : null,
      maritalStatus: formData?.maritalStatus || "",
      gdpr: formData?.gdpr,
      allowedHoursPerWeek: (formData?.nationality === "United Kingdom" || formData?.nationality === "Ireland") ? 0 : formData?.allowedHoursPerWeek,
    };

    if (!selectedCandidate?._id) {
      return;
    }

    try {
      // First check for duplicate candidates
      const response = await post('/api/candidate/check-duplicate', {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        currentCandidateId: selectedCandidate._id
      }, token);

      console.log('API Response===============================', response);

      if (response.data.isDuplicate === true) {
        toast.error(response.data.message);
        console.log('Duplicate candidate found with ID:', response.data.candidateId);
      } else {
        console.log('No duplicate found, proceeding with update');
        dispatch(updateCandidates(payload, () => { }, selectedCandidate._id, token));
      }
    } catch (error) {
      console.error('Error checking for duplicate candidates:', error);
      toast.error('Error checking for duplicate candidates');
    }
  };

  const formattedDate = (date) => {
    return date ? new Date(date).toISOString().split("T")[0] : null;
  };

  return (
    <>
      <Fragment>
        <div className="container-fluid">
          <div className="col-xl-12 col-lg-12">
            <div className="card profile-card card-bx m-b30 p-4">
              <div className="d-flex justify-content-start mb-2">
                <Button
                  variant="primary"
                  className="btn-sm"
                  onClick={handleBack}
                >
                  <i className="fa fa-arrow-left me-2"></i> Back
                </Button>
              </div>
              <Tab.Container activeKey={activeTab} onSelect={handleSelect}>
                <Nav as="ul" className="nav-tabs">
                  {tabData.map((data, i) => (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link eventKey={data.name.toLowerCase()}>
                        <i className={`la la-${data.icon} me-2`} />
                        {data.name}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
                <Tab.Content className="pt-4">
                  <Tab.Pane eventKey="master" key={1}>
                    <form onSubmit={handleSubmit}>
                      <div className="card-body">
                        <div className="row">
                          {[
                            { label: "Title", field: "title", required: true },
                            {
                              label: "First Name",
                              field: "firstName",
                              required: true,
                            },
                            {
                              label: "Last Name",
                              field: "lastName",
                              required: true,
                            },
                            {
                              label: "Known As",
                              field: "knownAs",
                              required: false,
                            },
                            {
                              label: "Home",
                              field: "homeType",
                              type: "select",
                              options: ["HOME", "OFFICE"],
                              required: true,
                            },
                            {
                              label: "Address Line 1",
                              field: "addressLine1",
                              required: false,
                            },
                            { label: "Address Line 2", field: "addressLine2" },
                            { label: "Town", field: "town", required: true },
                            { label: "County", field: "county" },
                            {
                              label: "Country",
                              field: "country",
                              required: true,
                            },
                            {
                              label: "Post Code",
                              field: "postCode",
                              required: true,
                            },
                            // { label: "Region", field: "region", required: false },
                            {
                              label: "Phone Type",
                              field: "phone",
                              type: "select",
                              options: ["", "Home", "Mobile"],
                              required: true,
                            },
                            {
                              label: "Phone Number",
                              field: "phoneNumber",
                              type: "number",
                              required: true,
                            },
                            {
                              label: "Email",
                              field: "email",
                              type: "email",
                              required: true,
                            },
                            // { label: "Office", field: "office", required: false },
                            // { label: "Sector", field: "sector", required: false, options: ["", "Industrial"], type:"select" },
                            {
                              label: "Person ID",
                              field: "personId",
                              required: false,
                              disabled: true,
                            },
                            {
                              label: "Source",
                              field: "source",
                              required: false,
                              options: ["", ...sourceList],
                              type: "select",
                            },
                          ].map(
                            ({
                              label,
                              field,
                              type = "text",
                              required = false,
                              options = [],
                              disabled = false,
                            }) => (
                              <div className="col-xl-6 mb-3" key={field}>
                                {type === "select" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <select
                                      className="form-control"
                                      name={field}
                                      value={formData[field]}
                                      disabled={isView || disabled}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    >
                                      {options?.map((itm) => (
                                        <option value={itm}>{itm}</option>
                                      ))}
                                    </select>
                                  </>
                                ) : (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <input
                                      type={type}
                                      name={field}
                                      disabled={isView || disabled}
                                      className="form-control"
                                      value={formData[field]}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    />
                                  </>
                                )}
                                {field === "postCode" &&
                                  results?.length > 0 && (
                                    <div
                                      style={{
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                        maxHeight: "150px", // Medium size scrollable div
                                        overflowY: "auto",
                                        marginTop: "5px",
                                        padding: "10px",
                                        backgroundColor: "#fff",
                                      }}
                                    >
                                      {results?.map((suggestion, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            padding: "5px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                          onClick={() =>
                                            handleSuggestionClick(suggestion)
                                          } // Handle click on suggestion
                                        >
                                          {suggestion.address}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                {errors[field] && (
                                  <small className="text-danger">
                                    {errors[field]}
                                  </small>
                                )}
                              </div>
                            )
                          )}
                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Consultant</label>
                            <input
                              type="text"
                              disabled
                              className="form-control"
                              value={formData.consultant}
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label className="form-label">
                              Registration Date
                            </label>
                            <br />
                            <DatePicker
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled={isView}
                              selected={formData.regDate}
                              onChange={(date) =>
                                handleInputChange("regDate", date)
                              }
                            />
                            {errors.regDate && (
                              <small className="text-danger">
                                {errors.regDate}
                              </small>
                            )}
                          </div>
                          {/* <div className="col-xl-6 mb-3">
                            <label className="form-label">Record Updated</label>
                            <br />
                            <DatePicker
                            dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled
                              selected={selectedCandidate?.updatedAt ? new Date(selectedCandidate?.updatedAt) : ''}
                              onChange={(date) =>
                                handleInputChange("recordUpdated", date)
                              }
                            />
                            
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Status Date</label>
                            <br />
                            <DatePicker
                            dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled={isView}
                              selected={formData.statusDate}
                              onChange={(date) => handleInputChange("statusDate", date)}
                            />
                            {errors.statusDate && (
                              <small className="text-danger">{errors.statusDate}</small>
                            )}
                          </div> */}
                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Status</label>
                            <select
                              className="default-select form-control"
                              value={formData.status}
                              disabled={isView}
                              onChange={(e) =>
                                handleInputChange("status", e.target.value)
                              }
                            >
                              <option value=""></option>
                              {statusList.map((itm) => (
                                <option value={itm}>{itm}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        {isView ? null : (
                          <button
                            type="submit"
                            className="btn btn-primary me-1"
                          >
                            Save
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => nav(-1)}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>

                      </div>
                    </form>
                  </Tab.Pane>

                  <Tab.Pane eventKey="details" key={1}>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label className="form-label">
                              Date Of Birth{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled={isView}
                              selected={formData.dateOfBirth}
                              onChange={(date) => {
                                handleInputChange("dateOfBirth", date)
                              }
                              }
                            />
                            {/* <input
                              type="date"
                              className="form-control"
                              value={formattedDate(formData?.dateOfBirth)}
                              disabled={isView}
                              onChange={(e) =>
                                handleInputChange("dateOfBirth", e.target.value)
                              }
                            /> */}
                            {errors.dateOfBirth && (
                              <small className="text-danger">
                                {errors.dateOfBirth}
                              </small>
                            )}
                          </div>

                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Age</label>
                            <input
                              type="text"
                              className="form-control"
                              disabled
                              value={formData.age}
                            />
                          </div>

                          <div className="col-xl-6 mb-3">
                            <label className="form-label">
                              Nationality <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control form-select"
                              disabled={isView}
                              value={formData.nationality}
                              onChange={(e) =>
                                handleInputChange("nationality", e.target.value)
                              }
                            >
                              <option value=""></option>
                              {countries?.map((itm) => (
                                <option value={itm}>{itm}</option>
                              ))}
                            </select>
                            {errors.nationality && (
                              <small className="text-danger">
                                {errors.nationality}
                              </small>
                            )}
                          </div>

                          {formData.nationality &&
                            formData.nationality !== "United Kingdom" &&
                            formData.nationality !== "Ireland" && (
                              <>
                                <div className="col-xl-6 mb-3">
                                  <label className="form-label">
                                    RTW Check expiry{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    disabled={isView}
                                    selected={formData.visaExpiry}
                                    onChange={(date) =>
                                      handleInputChange("visaExpiry", date)
                                    }
                                  />
                                  {errors.visaExpiry && (
                                    <small className="text-danger">
                                      {errors.visaExpiry}
                                    </small>
                                  )}
                                </div>

                                <div className="col-xl-6 mb-3">
                                  <label className="form-check-label">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={formData.hasNoLimitOnExpiry}
                                      disabled={isView}
                                      onChange={(e) =>
                                        handleInputChange(
                                          "hasNoLimitOnExpiry",
                                          e.target.checked
                                        )
                                      }
                                    />
                                    &nbsp;&nbsp; No limit on visa expiration?
                                  </label>
                                </div>

                                <div className="col-xl-6 mb-3">
                                  <label className="form-label">
                                    Visa Type{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control form-select"
                                    disabled={isView}
                                    value={formData.visaType}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "visaType",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value=""></option>
                                    {visaTypes?.map((itm) => (
                                      <option value={itm}>{itm}</option>
                                    ))}
                                  </select>
                                  {errors.visaType && (
                                    <small className="text-danger">
                                      {errors.visaType}
                                    </small>
                                  )}
                                </div>

                                <div className="col-xl-6 mb-3">
                                  <label className="form-label">
                                    Allowed Working Hours Per Week
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    disabled={isView}
                                    value={formData.allowedHoursPerWeek}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "allowedHoursPerWeek",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </>
                            )}

                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Marital Status</label>
                            <select
                              className="form-control form-select"
                              value={formData.maritalStatus}
                              disabled={isView}
                              onChange={(e) =>
                                handleInputChange(
                                  "maritalStatus",
                                  e.target.value
                                )
                              }
                            >
                              <option value=""></option>
                              <option value="Married">Married</option>
                              <option value="Single">Single</option>
                            </select>
                          </div>
                          <div className="row">
                            <div className="col-xl-6 mb-3">
                              <label className="form-check-label">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={formData.hasVehicle}
                                  disabled={isView}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "hasVehicle",
                                      e.target.checked
                                    )
                                  }
                                />
                                &nbsp;&nbsp; Does the candidate have vehicle ?
                              </label>
                            </div>

                            {formData.hasVehicle && (
                              <div className="col-xl-6 mb-3">
                                <label className="form-label">
                                  Vehicle Registration Number{" "}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formData.vehicleLicense}
                                  disabled={isView}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "vehicleLicense",
                                      e.target.value
                                    )
                                  }
                                />
                                {errors.vehicleLicense && (
                                  <small className="text-danger">
                                    {errors.vehicleLicense}
                                  </small>
                                )}
                              </div>
                            )}
                          </div>


                          <div className="row">
                            <div className="col-xl-6 mb-3">
                              <label className="form-check-label">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={formData.hasDrivingLicense}
                                  disabled={isView}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "hasDrivingLicense",
                                      e.target.checked
                                    )
                                  }
                                />
                                &nbsp;&nbsp; Do you have driving license ?
                              </label>
                            </div>

                            {formData.hasDrivingLicense && (
                              <div className="col-xl-6 mb-3">
                                <label className="form-label">
                                  Driving License{" "}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formData.drivingLicense}
                                  disabled={isView}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "drivingLicense",
                                      e.target.value
                                    )
                                  }
                                />
                                {errors.drivingLicense && (
                                  <small className="text-danger">
                                    {errors.drivingLicense}
                                  </small>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <div>
                          {isView ? null : (
                            <button
                              type="submit"
                              className="btn btn-primary me-1"
                            >
                              Update
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => nav(-1)}
                            className="btn btn-danger light ms-1"
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="card-footer"></div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="classification" key={1}>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label className="form-label">
                              Industry Sector{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control form-select overflow-y"
                              value={formData.industrySector}
                              disabled={isView}
                              onChange={(e) =>
                                handleInputChange(
                                  "industrySector",
                                  e.target.value
                                )
                              }
                            >
                              <option value=""></option>
                              {industrySector?.map((itm) => (
                                <option value={itm}>{itm}</option>
                              ))}
                            </select>
                            {errors.industrySector && (
                              <small className="text-danger">
                                {errors.industrySector}
                              </small>
                            )}
                          </div>

                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Job Titles</label>
                            <select
                              className="form-control form-select"
                              value={formData.jobTitles}
                              disabled={isView}
                              onChange={(e) =>
                                handleInputChange("jobTitles", e.target.value)
                              }
                            >
                              <option value=""></option>
                              {jobTitleList.map((itm) => (
                                <option value={itm}>{itm}</option>
                              ))}
                            </select>
                          </div>

                          {/* <div className="col-xl-6 mb-3">
                            <label className="form-label">Skills</label>
                            <select
                              className="form-control form-select"
                              value={formData.skills}
                              disabled={isView}
                              onChange={(e) =>
                                handleInputChange("skills", e.target.value)
                              }
                            >
                              <option value=""></option>
                              {skillList.map((itm) => (
                                <option value={itm}>{itm}</option>
                              ))}
                            </select>
                          </div> */}

                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Qualification</label>
                            <Select
                              isMulti
                              className="basic-multi-select"
                              classNamePrefix="select"
                              value={qualificationList
                                .filter((itm) => formData.qualifications?.includes(itm))
                                .map((itm) => ({ value: itm, label: itm }))}
                              isDisabled={isView}
                              onChange={(selectedOptions) =>
                                handleInputChange(
                                  "qualifications",
                                  selectedOptions.map((option) => option.value)
                                )
                              }
                              options={qualificationList.map((itm) => ({ value: itm, label: itm }))}
                            />
                          </div>

                          <div className="col-xl-6 mb-3">
                            <label className="form-label">Marketing</label>
                            <select
                              className="form-control form-select"
                              value={formData.marketing}
                              disabled={isView}
                              onChange={(e) =>
                                handleInputChange("marketing", e.target.value)
                              }
                            >
                              <option value=""></option>
                              <option value="Opt-in">Opt-in</option>
                              <option value="Opt-out">Opt-out</option>
                            </select>
                          </div>
                        </div>
                        <div>
                          {isView ? null : (
                            <button
                              type="submit"
                              className="btn btn-primary me-1"
                            >
                              Update
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => nav(-1)}
                            className="btn btn-danger light ms-1"
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="card-footer"></div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="payroll" key={1}>
                    <form onSubmit={handleSubmit}>
                      <div className="card-body">
                        <div className="col-xl-12 mb-12">
                          <h3>Temp Details</h3>
                          <hr />
                        </div>
                        <div className="row">
                          {[
                            {
                              label: "Payroll Number",
                              field: "payrollNo",
                              type: "number",
                              disabled: true,
                              required: true,
                            },
                            {
                              label: "Weeks Employed",
                              field: "weeksEmployed",
                              type: "number",
                              disabled: true,
                            },
                            {
                              label: "12 Week Average",
                              field: "twelveWeekAverage",
                              type: "number",
                            },
                            // {
                            //   label: "Temp Start",
                            //   field: "tempStartDate",
                            //   required: false,
                            //   type: "date",
                            // },
                            // {
                            //   label: "Temp Finish",
                            //   field: "tempFinishDate",
                            //   required: false,
                            //   type: "date",
                            // },
                            {
                              label: "N.I. No",
                              field: "niNo",
                              required: true,
                            },
                            {
                              label: "Temp/Perm",
                              field: "type",
                              type: "select",
                              options: ["BOTH", "Temporary", "Permanent"],
                              required: false,
                            },
                            // {
                            //   label: "Increment", field: "increment", type: "select",
                            //   options: ["1", "2", "3"],
                            //   required: false,
                            // },

                            {
                              label: "Availability Date",
                              field: "availDate",
                              type: "date",
                              required: false,
                            },
                            {
                              label: "Minimum Rate for",
                              field: "rateType",
                              required: false,
                              type: "select",
                              options: ["BASIC"],
                            },
                            {
                              label: "Rate (£/hour)",
                              field: "rate",
                              required: false,
                            },
                            {
                              label: "AWR Type",
                              field: "awrType",
                              type: "select",
                              options: ["Normal"],
                              required: false,
                            },
                            {
                              label: "Hours per week",
                              field: "hoursPerWeek",
                              type: "number",
                              required: false,
                            },
                          ].map(
                            ({
                              label,
                              field,
                              type = "text",
                              required = false,
                              options = [],
                              disabled = false,
                            }) => (
                              <div className="col-xl-6 mb-3" key={field}>
                                {type === "select" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <select
                                      className="form-control"
                                      value={formData[field]}
                                      disabled={isView || disabled}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    >
                                      {options?.map((itm) => (
                                        <option value={itm}>{itm}</option>
                                      ))}
                                    </select>
                                  </>
                                ) : type === "date" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <DatePicker
                                      dateFormat="dd/MM/yyyy"
                                      disabled={isView}
                                      className="form-control"
                                      selected={formData[field]}
                                      onChange={(date) =>
                                        handleInputChange(field, date)
                                      }
                                    />
                                  </>
                                ) : (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    {field === "weeksEmployed" ? (
                                      <input
                                        disabled={isView || disabled}
                                        type={type}
                                        className="form-control"
                                        value={weekEmployed}
                                        onChange={(e) =>
                                          handleInputChange(
                                            field,
                                            e.target.value
                                          )
                                        }
                                      />
                                    ) : (
                                      <input
                                        disabled={isView || disabled}
                                        type={type}
                                        className="form-control"
                                        value={formData[field]}
                                        onChange={(e) =>
                                          handleInputChange(
                                            field,
                                            e.target.value
                                          )
                                        }
                                      />
                                    )}
                                  </>
                                )}

                                {errors[field] && (
                                  <small className="text-danger">
                                    {errors[field]}
                                  </small>
                                )}
                              </div>
                            )
                          )}
                        </div>
                        <div className="col-xl-12 mb-12">
                          <h3>Payment Details</h3>
                          <hr />
                        </div>
                        <div className="row">
                          {[
                            {
                              label: "Bank Name",
                              field: "paymentDetails.bankName",
                              required: false,
                            },
                            {
                              label: "Account Name",
                              field: "paymentDetails.accountName",
                              required: false,
                            },
                            {
                              label: "Account No",
                              field: "paymentDetails.accountNo",
                              required: false,
                            },
                            {
                              label: "Sort Code",
                              field: "paymentDetails.sortCode",
                              required: false,
                            },
                            {
                              label: "Building Society No.",
                              field: "paymentDetails.buildingSocNo",
                              required: false,
                            },
                            {
                              label: "Starter Declaration",
                              field: "paymentDetails.startedDeclaration",
                              type: "select",
                              options: [],
                            },
                            {
                              label: "Starter Declaration By Employee",
                              field:
                                "paymentDetails.isStartedDeclarationByEmployee",
                              type: "select",
                              options: ["Yes", "No"],
                            },
                            {
                              label: "Public Sector Worker",
                              field: "paymentDetails.isPublicSectorWorker",
                              type: "select",
                              options: ["Yes", "No"],
                            },
                            {
                              label: "Employment Type",
                              field: "paymentDetails.employmentType",
                              type: "select",
                              options: [...employmentTypeList],
                              required: true,
                            },
                            {
                              label: "Tax Form",
                              field: "paymentDetails.taxForm",
                              type: "select",
                              options: ["Yes", "No"],
                            },
                            {
                              label: "Payment Method",
                              field: "paymentDetails.paymentMethod",
                              type: "select",
                              options: ["BACS"],
                            },

                            {
                              label: "Ltd Company",
                              field: "paymentDetails.ltdCompany",
                              required: false,
                            },
                            {
                              label: "Ltd Company No.",
                              field: "paymentDetails.ltdCompanyNo",
                              required: false,
                              type: "number",
                            },
                            {
                              label: "Vat Code",
                              field: "paymentDetails.vatCOde",
                              required: false,
                            },
                          ].map(
                            ({
                              label,
                              field,
                              type = "text",
                              required = false,
                              options = [],
                            }) => (
                              <div className="col-xl-6 mb-3" key={field}>
                                {type === "select" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <select
                                      disabled={isView}
                                      className="form-control"
                                      value={formData[field] || ""}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    >
                                      {options?.map((itm) => (
                                        <option value={itm}>{itm}</option>
                                      ))}
                                    </select>
                                  </>
                                ) : type === "date" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <DatePicker
                                      disabled={isView}
                                      dateFormat="dd/MM/yyyy"
                                      className="form-control"
                                      selected={formData[field]}
                                      onChange={(date) =>
                                        handleInputChange(field, date)
                                      }
                                    />
                                  </>
                                ) : (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <input
                                      type={type}
                                      className="form-control"
                                      value={formData[field]}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    />
                                  </>
                                )}

                                {errors[field] && (
                                  <small className="text-danger">
                                    {errors[field]}
                                  </small>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                      <div className="card-footer">
                        {isView ? null : (
                          <button
                            type="submit"
                            className="btn btn-primary me-1"
                          >
                            Save
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => nav(-1)}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </Tab.Pane>

                  <Tab.Pane eventKey="pen picture" key={1}>
                    <form onSubmit={handleSubmit}>
                      <div className="card-body">
                        <div className="row">
                          {[
                            {
                              label: "Pen Picture",
                              field: "penPicture",
                              required: false,
                              type: "textarea",
                            },
                            // {
                            //   label: "Testimonial",
                            //   field: "testimonial",
                            //   type: "textarea",
                            // },
                          ].map(
                            ({
                              label,
                              field,
                              type = "text",
                              required = false,
                              options = [],
                            }) => (
                              <div className="col-xl-6 mb-3" key={field}>
                                {type === "select" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <select
                                      className="form-control"
                                      disabled={isView}
                                      value={formData[field]}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    >
                                      {options?.map((itm) => (
                                        <option value={itm}>{itm}</option>
                                      ))}
                                    </select>
                                  </>
                                ) : type === "textarea" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <textarea
                                      disabled={isView}
                                      name="textarea"
                                      id="textarea"
                                      cols={30}
                                      rows={5}
                                      className="form-control bg-transparent"
                                      value={formData[field]}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    />
                                  </>
                                ) : type === "date" ? (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <DatePicker
                                      dateFormat="dd/MM/yyyy"
                                      className="form-control"
                                      disabled={isView}
                                      selected={formData[field]}
                                      onChange={(date) =>
                                        handleInputChange(field, date)
                                      }
                                    />
                                  </>
                                ) : (
                                  <>
                                    <label className="form-label">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <input
                                      type={type}
                                      disabled={isView}
                                      className="form-control"
                                      value={formData[field]}
                                      onChange={(e) =>
                                        handleInputChange(field, e.target.value)
                                      }
                                    />
                                  </>
                                )}

                                {errors[field] && (
                                  <small className="text-danger">
                                    {errors[field]}
                                  </small>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                      <div className="card-footer">
                        {isView ? null : (
                          <button
                            type="submit"
                            className="btn btn-primary me-1"
                          >
                            Save
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => nav(-1)}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </Tab.Pane>

                  {/* <Tab.Pane eventKey="cv" key={1}>
                    <div className="card-body">
                      <div className="row">
                        <div
                          style={{
                            width: "100%",
                            height: "100vh",
                            border: "none",
                          }}
                        >
                          <iframe
                            src="https://docs.google.com/document/d/1nr1JsQu0mrSEtKhae2d18XpHsqFdQcVGUBVRY91N6eM/preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              border: "none",
                            }}
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-xl-2 mb-2">
                          <Button
                            type="button"
                            className="me-2"
                            variant="light"
                          >
                            <i className="fa-solid fa-copy me-2"></i> Copy CV
                          </Button>
                        </div>
                        <div className="col-xl-2 mb-2">
                          <Button
                            type="button"
                            className="me-2"
                            variant="light"
                          >
                            <i className="fa-solid fa-code-compare me-2"></i>{" "}
                            Code CV
                          </Button>
                        </div>
                        <div className="col-xl-2 mb-2">
                          <Button
                            type="button"
                            className="me-2"
                            variant="light"
                          >
                            <i className="fa-solid fa-file-import me-2"></i>{" "}
                            Import From Outlook
                          </Button>
                        </div>
                        <div className="col-xl-2 mb-2">
                          <Button
                            type="button"
                            className="me-2"
                            variant="light"
                          >
                            <i className="fa-solid fa-file me-2"></i> Other CVs
                          </Button>
                        </div>
                        <div className="col-xl-2 mb-2">
                          <>
                            <label className="form-label">
                              CV Updated
                              {<span className="text-danger">*</span>}
                            </label>
                            <input type="date" className="form-control" />
                          </>
                        </div>
                        <div className="col-xl-2 mb-2">
                          <Button
                            type="button"
                            className="me-2"
                            variant="light"
                          >
                            <i className="fa-solid fa-file-word me-2"></i> Edit
                            in Word
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane> */}

                  <Tab.Pane eventKey="jobs" key={1}>
                    <div className="card-body">
                      <CandidateJobs />
                    </div>
                    <div className="card-footer"></div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="gdpr" key={1}>
                    <form onSubmit={handleSubmit}>
                      <div className="card-body">
                        <CandidateGDPR
                          formData={formData}
                          isView={isView}
                          handleInputChange={handleInputChange}
                          submit={handleSubmit}
                          close={() => {
                            setActiveTab("master");
                            // setAddEmploye(false);
                            // nav("/candidates");
                          }}
                        />
                      </div>
                      <div className="card-footer"></div>
                    </form>
                  </Tab.Pane>

                  <Tab.Pane eventKey="registration form " key={1}>
                    <div className="card-body">
                      <Documents
                        candidateId={updateCandidateId}
                        token={token}
                        close={() => {
                          setActiveTab("master");
                          // setAddEmploye(false);
                          // nav("/candidates");
                        }}
                      />
                    </div>
                    <div className="card-footer"></div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="email log" key={4}>
                    <EmailLog token={token} emailList={[formData?.email]} />
                  </Tab.Pane>

                  <Tab.Pane eventKey="contact log" key={3}>
                    <ViewContactLog
                      contactLogRef={contactLogRef}
                      token={token}
                      contactPersonId={updateCandidateId}
                    />
                  </Tab.Pane>

                  <Tab.Pane eventKey="compliance criteria" key={1}>
                    <ComplianceCriteria
                      isView={isView}
                      selectedCandidate={selectedCandidate}
                      token={token}
                      close={() => {
                        setActiveTab("master");
                      }}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="id card" key={1}>
                    <IDCard
                      idCardRef={idCardRef}
                      token={token}
                      isView={isView}
                      selectedCandidate={selectedCandidate}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </Fragment>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    selectedCandidate: state.candidates.selectedCandidate,
    candidateSources: state?.dropDownValues?.dropDownValues?.candidateSources || [],
    candidateStatus: state?.dropDownValues?.dropDownValues?.candidateStatus || [],
    employmentTypes: state?.dropDownValues?.dropDownValues?.employmentTypes || [],
    visaTypeValues: state?.dropDownValues?.dropDownValues?.visaTypeList || [],
    qualification: state?.dropDownValues?.dropDownValues?.qualification || [],
    skills: state?.dropDownValues?.dropDownValues?.skills || [],
    jobTitle: state?.dropDownValues?.dropDownValues?.jobTitle || []
  };
};

export default withRouter(connect(mapStateToProps)(AddCandidateMaster));
